const config = {
    API_BASE_URL: 'https://antikdantel.com.tr/adsapi',
    WEB_BASE_URL: 'https://antikdantel.com.tr/ads',
    IMAGE_BASE_URL: 'https://antikdantel.com.tr/ADS'
};


/*
const config = {
    API_BASE_URL: 'http://localhost:5005',
    WEB_BASE_URL: 'http://localhost:3000'
};
*/
export default config;
